// Vendor Libs
import React from 'react';
import {Route} from 'react-router-dom';

// Components
import FlexDashboard from '../components-core/flex-dashboard';
import SubShelfDetail from '../components-search-data/subshelf-detail';

// Configs
import getDashboardConfig from '../configs/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'tabset',
                children: [
                    {
                        id: 'SUBSHELFDETAIL',
                        type: 'tab',
                        name: '',
                        component: SubShelfDetail,
                    },
                ],
            },
        ],
    },
};

const DashboardSubShelf = properties => {
    if (properties.match.isExact) {
        return <FlexDashboard dashboardConfig={getDashboardConfig(dashboardConfig)} dashboardName="subshelf" />;
    }
    // How to check if the list of routes does not keep growing???
    return (
        <div>
            <Route component={DashboardSubShelf} path={`${properties.match.url}/:shelfid`} />
        </div>
    );
};

export default DashboardSubShelf;
